<script>
import {
    Block,
    BlockTitle,
    Link,
    Tabs,
    Tab
} from 'framework7-svelte';
import { onMount } from 'svelte';
onMount(() => {

})
</script>
<style>

</style>
<Block strong mediumInset style="text-align: justify;">
    <p>CONABIO. Comisión Nacional para el Conocimiento de la Biodiversidad. 2021. 
    Sistema de Alerta Temprana de Incendios Forestales (SATIF) para México y Centroamérica. 
    En <u>http://incendios.conabio.gob.mx/</u></p>

    <p>Además, en la sección Información disponible se especifica la forma de citar para cada producto.</p>
</Block>
